/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SpeakerOut } from './speakerOut';

export interface SourceSpeakersOut {
  source_id: string;
  kind: string;
  speakers: SpeakerOut[];
}
